export const environment = {
  production: true,
  defaultLanguage: 'en-US',
};
